<template>

  <div>
    <div>
      <router-view/>
    </div>
    <BookingLiveChatWidget />
  </div>
  
  </template>

<script>
import BookingLiveChatWidget from '@/global-components/BookingLiveChatWidget.vue';

export default {
  name: 'App',
  components: {
    BookingLiveChatWidget,
  },
};
</script>

<style lang="scss">
#app {
  font-family: 'Inter', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
